import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import Moment from 'moment'
import Numeral from 'numeral'
import { getTimezoneDate } from 'utils/date'

import DatePicker from 'material-ui/DatePicker'

import {getMonth} from 'utils/date'
import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { transactionEx } from 'selectors/transactions'

let select = dirtyRead(
	(state, props) => ({
		transaction: transactionEx(state, props.objectID)
	})
)

export class DueDatePicker extends Component{
	render(){
		let { props } = this
		return(
				<div style={{margin: "0px", display:"inline-block", width: "50%"}}>
                    <p style={{marginTop: "10px", marginBottom: "-12px", userSelect: "none", color: "rgba(0, 0, 0, 0.298039)", fontWeight: "100", fontSize: "10px"}} >
                    Due date</p>
                    <DatePicker
                        style={{
                            color: "#000"
                        }}
                        textFieldStyle={{
                            fontSize: "16px"
                            , width: "100px"
                            , height: "36px"
                            , color: "#000"
                        }}
                        underlineStyle={{
                            borderBottom: props.transaction.dueDate ? "0px solid" : "0px solid"
                        }}
                        inputStyle={{color: "#000"}}
                        underlineDisabledStyle={{borderBottom: "0px solid"}}
                        hintText="Select"
						formatDate= {(date)=>getTimezoneDate(date).getDate().toString() + ' ' + getMonth(getTimezoneDate(date).getMonth()).toString() + ' ' + getTimezoneDate(date).getFullYear().toString()}
                        hintStyle={{top: "8px"}}
                        style={{width: "100px", height: "35px", marginTop: "8px"}}
                        value={(props.transaction.dueDate)?getTimezoneDate(props.transaction.dueDate):""}
						disabled={true}
                        onChange={(evt, value)=>{
							if (props.transaction.qbid) return false
                            props.STAGE({
                                _id: props.objectID
                                , dueDate: value.getFullYear()+'-'+(value.getMonth()+1<10 ? "0" : "")+(value.getMonth()+1)+'-'+(value.getDate()<10 ? "0" : "")+value.getDate()
                            })}
                        }
                    />
                </div>
		)
	}
}

export default connect(select, dataActions)(DueDatePicker)



// WEBPACK FOOTER //
// ./src/routes/landlord/transactionForm/DueDatePicker.js